export default __webpack_public_path__ + "static/media/ltc.b1c4cf3b.png";